import { useRhythmicLogger } from '#imports'

import { getIterationsCollection } from '../../getCollections'

const logger = useRhythmicLogger('useTeamContext:deleteIteration')

export interface DeleteTeamIterationContext {
  teamId: string
}

function validateParams(iterationId: string, context: DeleteTeamIterationContext) {
  if (!iterationId) {
    const error = new Error('Team iteration identifier is required')
    logger.error('delete team iteration blocked: missing iteration identifier', { context })
    throw error
  }
  const { teamId } = context

  return { iterationId, teamId }
}

/**
 * Deletes a team iteration from the local collection.
 */
export default async function handleDeleteTeamIteration(iterationId: string, context: DeleteTeamIterationContext) {
  try {
    const { teamId } = validateParams(iterationId, context)
    const listCollection = getIterationsCollection(teamId)
    listCollection.delete(iterationId)

    logger.info('Team iteration deleted successfully', {
      iterationId,
      teamId,
    })
  } catch (error) {
    logger.error('Failed to delete team iteration', {
      iterationId,
      context,
      error,
    })
    if (error instanceof Error) throw error
    throw new Error('Failed to delete team iteration')
  }
}
